import React from 'react';
import { Button, ButtonGroup, DropdownButton, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

import { Table, Pricing } from 'services/action';
import { FormPricing } from 'ui/screens/authorized/_shared';

const initialState = {
  privilege: null,
  isShow: false,
  isUpdate: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['pricing']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Pricing.Delete']
  );

  const [{ privilege, isShow, isUpdate }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, isShow: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Pricing.$delete(data?.id));
    if (del?.message === 'success') {
      $resetTable();
    }
  };

  const $resetTable = async () => {
    $handleClose();
    Dispatch(Table.$reload('pricing', StateTable));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    return (
      <div className="row">
        <DropdownButton
          as={ButtonGroup}
          variant="transparent"
          size="md"
          className="no-carret tbl-action"
          title={<Fi.FiMoreVertical size={13} color="gray" />}
        >
          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isUpdate: true }))
            }
          >
            <Fi.FiEdit size={15} color="#202020" className="me-2" />
            <span className="mt-1">Perbaharui</span>
          </button>

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            <Fi.FiTrash2 size={15} className="me-2" />
            <span className="mt-1">Hapus</span>
          </button>
        </DropdownButton>

        {/* modal delete */}
        <Modal
          show={isShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-danger" />
            <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>

            {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="danger"
                  className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                  onClick={$handleDelete}
                  disabled={StateLoading}
                >
                  Hapus
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdate}
          onHide={() =>
            setState((prevState) => ({ ...prevState, isUpdate: false }))
          }
          backdrop="static"
          centered
          size="lg"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui Harga</Modal.Title>
          </Modal.Header>
          <FormPricing
            onClose={() => {
              setState((prevState) => ({ ...prevState, isUpdate: false }));
            }}
            onSuccess={$resetTable}
            data={data}
          />
        </Modal>
      </div>
    );
  }

  return false;
};

export default Action;
